import { DriverDispatchCandidate } from "@src/shipments/utils/makeDispatchCandidateViews";

// "Other Online Drivers": the online regular drivers the recommended list left out
// (the ones that failed the distance / vehicle / weight filters on the server).
// Built from the plain drivers list so the server only optimizes routes for the
// recommended drivers. Keeps the order of onlineRegularDrivers.
export const pickOtherOnlineDrivers = (
  onlineRegularDrivers: DriverDispatchCandidate[],
  recommendedDriverIds: Set<string>
): DriverDispatchCandidate[] =>
  onlineRegularDrivers.filter(
    (candidate) => !recommendedDriverIds.has(candidate.driver.id)
  );
